import { render } from "./ViewTeamSheet.vue?vue&type=template&id=b3a8aa7c&scoped=true"
import script from "./ViewTeamSheet.vue?vue&type=script&lang=js"
export * from "./ViewTeamSheet.vue?vue&type=script&lang=js"

import "./ViewTeamSheet.vue?vue&type=style&index=0&id=b3a8aa7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3a8aa7c"]])

export default __exports__